import React from 'react'

import Button from './button'
import bem from '../utils/bem'
import './wrapping-buttons.scss'


export default function WrappingButtons({
    onTopClick,
    onBottomClick,
    grow,
    active,
    children,
    extraClassName,
    disabled,
}) {
    function handleKeyDown(event) {
        if (disabled) {
            return
        }

        const isInput = event.target.tagName === "INPUT" || event.target.tagName === "TEXTAREA"

        if (isInput) {
            if (event.key === "ArrowUp") {
                event.preventDefault()
                onTopClick?.()
            } else if (event.key === "ArrowDown") {
                event.preventDefault()
                onBottomClick?.()
            }
        }
    }

    return <span
        className={bem("wrapping-buttons").m({grow}).x(extraClassName)}
        onKeyDown={handleKeyDown}
    >
        <Button
            onClick={onTopClick}
            extraClassName={bem("wrapping-button").m({top: true, disabled, active})}
            tabIndex="-1"
            disabled={disabled}
        />
        {children}
        <Button
            onClick={onBottomClick}
            extraClassName={bem("wrapping-button").m({bottom: true, disabled, active})}
            tabIndex="-1"
            disabled={disabled}
        />
    </span>
}